import { Phone, Mail, MapPin, Instagram, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white/80 py-16 text-sm">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-6 text-white">A.C.S. NHVelo</h3>
            <div className="space-y-3">
              <div className="pt-4">
                <p className="mb-2">Velo Coach - Claudiu Sebastian Marian</p>
                <a href="tel:+40720200584" className="flex items-center hover:text-orange-500 transition-colors">
                  <Phone className="w-4 h-4 mr-2" />
                  +40 720 200 584
                </a>
              </div>
              <div className="pt-2">
                <p className="mb-2">Trail Builder - Ciprian Ion</p>
                <a href="tel:+40736367830" className="flex items-center hover:text-orange-500 transition-colors">
                  <Phone className="w-4 h-4 mr-2" />
                  +40 736 367 830
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-6 text-white">Link-uri Rapide</h3>
            <div className="space-y-3">
              <Link to="/bikepark" className="block hover:text-orange-500 transition-colors">
                BikePark
              </Link>
              <Link to="/team" className="block hover:text-orange-500 transition-colors">
                Echipă
              </Link>
              <a href="mailto:velocipedmountain@gmail.com" className="flex items-center hover:text-orange-500 transition-colors">
                <Mail className="w-4 h-4 mr-2" />
                velocipedmountain@gmail.com
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-6 text-white">Social Media</h3>
            <div className="space-y-3">
              <a 
                href="https://www.instagram.com/nhveloracing" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center hover:text-orange-500 transition-colors"
              >
                <Instagram className="w-4 h-4 mr-2" />
                @NHVELORACING
              </a>
              <a 
                href="https://www.youtube.com/@velocipedmountain" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center hover:text-orange-500 transition-colors"
              >
                <Youtube className="w-4 h-4 mr-2" />
                NH Velo Racing Team
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} NH Velo Racing Team. Toate drepturile rezervate.
        </div>
      </div>
    </footer>
  );
}